import * as _ from 'lodash';
import * as React from 'react'
import { Col, Row } from 'reactstrap';
import { HttpRequest } from '../../../util/http';
import { IFilters, userData } from '../../../util/userData';
import { Button } from '../Button';
import { DataList, DataListRowLink } from '../DataList';
import { Popover } from '../Popover';
import { IQuestionData, IQuestionDataResponse, IStatisticData } from './interfaces';

interface IQuestionsPopoverProps<isMulti extends boolean> {
  multi?: isMulti extends true ? true : undefined
  questionId: string
  statId: isMulti extends true ? string[] : string
  useHeaderView?: true
  useLinkView?: true
  dataUrl: string
  rightAlign?: boolean
  centerAlign?: boolean
  filtersObject?: IFilters
}

interface IQuestionsPopoverState<isMulti extends boolean> {
  selectedQuestionId: string
  selectedStatValue: isMulti extends true ? string[] : string
  questions: IQuestionData[]
  showLoader: boolean
  loadingQuestions: boolean
}

export class QuestionsPopover<isMulti extends boolean = false> extends React.Component<IQuestionsPopoverProps<isMulti>, IQuestionsPopoverState<isMulti>> {

  state: IQuestionsPopoverState<isMulti> = {
    selectedQuestionId: '',
    selectedStatValue: this.props.statId, //kludge
    showLoader: false,
    loadingQuestions: true,
    questions: []
  }

  currentHeirarchy: string
  currentSurvey: string
  loadQuestionsDebounce = _.debounce((filters: any) => this.loadQuestionsDebounceFN(filters), 50)
  removeUserDataListener: () => void = () => { /**/ }

  componentWillMount() {
    const { statId, questionId, filtersObject } = this.props
    const selectedStatValue = statId
    const selectedQuestionId = questionId

    this.setState({ selectedQuestionId, selectedStatValue })

    if (!filtersObject) {
      this.removeUserDataListener = userData.listen('filters', (filters) => this.loadQuestions(filters))
    } else {
      this.loadQuestionsByPropsUpdate(filtersObject);
    }
  }

  loadQuestionsByPropsUpdate(filtersObject: IFilters) {
    this.currentHeirarchy = filtersObject.hier;
    this.currentSurvey = filtersObject.survey;
    this.loadQuestionsDebounceFN(filtersObject);
  }

  componentWillReceiveProps(nextProps: IQuestionsPopoverProps<isMulti>) {
    let { selectedQuestionId, selectedStatValue } = this.state;

    if (!selectedQuestionId && nextProps.questionId) {
      selectedQuestionId = nextProps.questionId

      this.setState({ selectedQuestionId })
    }

    if (_.isEmpty(selectedStatValue) && !_.isEmpty(nextProps.statId)) {
      selectedStatValue = nextProps.statId

      this.setState({ selectedStatValue })
    }
  }

  componentDidUpdate(prevProps: Readonly<IQuestionsPopoverProps<isMulti>>, prevState: Readonly<IQuestionsPopoverState<isMulti>>, snapshot?: any) {
    if (prevProps.filtersObject !== this.props.filtersObject) {
      this.loadQuestionsByPropsUpdate(this.props.filtersObject);
    }
  }

  componentWillUnmount() {
    this.removeUserDataListener()
  }

  isOnCommentDetailsOrCoachingOverviewPage() {
    const { href } = window.location

    return href.indexOf('coachingoverview') !== -1 || href.indexOf('commentdetails') !== -1
  }

  loadQuestions(filters: IFilters | null) {
    let dirty = false

    if (filters === null) {
      dirty = true;
    } else {
      if (this.currentHeirarchy !== filters.hier) {
        dirty = true
        this.currentHeirarchy = filters.hier
      }

      if (this.currentSurvey !== filters.survey) {
        dirty = true
        this.currentSurvey = filters.survey
      }

      if (!('q' in filters)) {
        dirty = true
      }
    }

    if (dirty) {
      this.loadQuestionsDebounce(filters)
    }
  }

  loadQuestionsDebounceFN(filters: IFilters | null) {
    const { dataUrl } = this.props
    if (filters.displayAll) {
      filters.displayAll = false
    }
    let loadingQuestions = true
    const data = filters
    const method = 'POST'
    let fullPath = '/scripts/' + dataUrl
    if (fullPath.endsWith('.php')) {
      fullPath = fullPath.slice(0, -4); // Removes the last 4 characters ("")
    }

    this.setState({ questions: [], loadingQuestions }, () => {
      HttpRequest.fetch<IQuestionDataResponse>(fullPath, { data, method })
        .then(({ values: questions }) => {
          const correctHier = this.currentHeirarchy === filters.hier
          const correctSurvey = this.currentSurvey === filters.survey
          loadingQuestions = false

          if (correctHier && correctSurvey) {
            questions.forEach((question) => {
              const hasChildren = Array.isArray(question.children) && question.children.length >= 0
              const isOnPageToShowAllQuestion = this.isOnCommentDetailsOrCoachingOverviewPage()
              const questionSaysToShowAll = question.display_all === 1
              const shouldAddAllOption = hasChildren && isOnPageToShowAllQuestion && questionSaysToShowAll

              if (shouldAddAllOption) {
                const value = this.getDisplayAllValue(question)
                const label = 'All'
                const val = 'ALL'
                question.children.splice(0, 0, { label, value, val })
              }
            })

            this.setState({ questions, loadingQuestions })
          }
        })
    })
  }

  getDisplayAllValue(question: IQuestionData) {
    return `${question.qid}_displayvals#${question.display}#ALL`
  }

  changeQuestion() {
    const { selectedStatValue, questions, selectedQuestionId } = this.state
    const filters = userData.getFilters()
    const lastSelectedStatVal = selectedStatValue instanceof Array ? selectedStatValue[selectedStatValue.length - 1] : selectedStatValue;
    const selectedQuestion = questions.find((q) => q.qid === selectedQuestionId)
    const selectedStatistic = selectedQuestion.children.find((c) => c.val === lastSelectedStatVal)
    const landvs = selectedStatistic.value.split('#');

    let metric = landvs[0];
    const question = landvs[1];
    const measure = landvs[2];

    filters.metric = metric;
    filters.q = question;
    filters.measure = measure;

    metric = metric.replace(filters.survey, '');
    const vals = metric.split('_');
    filters.stat = vals.pop();
    filters.question = vals.join('_');

    if (selectedStatValue instanceof Array) {
      filters.stats = selectedStatValue;
    } else if ('stats' in filters) {
      delete filters.stats;
    }

    userData.updateFilters(filters, true);

    if (typeof window.pullCoachingOverview === 'function') {
      //Coaching Forms Page
      window.pullCoachingOverview(filters, () => {
        this.setState({ showLoader: false })
      });
    }
  }

  triggerStatWasSelected(stat: IStatisticData) {
    const { multi = false } = this.props
    const { selectedQuestionId, questions } = this.state
    let { selectedStatValue } = this.state

    if (multi && selectedStatValue instanceof Array) {
      const statIsAll = stat.label.toLowerCase() === 'all';

      if (statIsAll) {
        //@ts-ignore
        selectedStatValue = [stat.val]
      } else {
        //@ts-ignore
        selectedStatValue = (selectedStatValue as string[]).filter((ssv) => ssv !== '')
        const statIndex = (selectedStatValue as string[]).findIndex((ssv) => ssv === stat.val)

        if (statIndex >= 0) {
          //@ts-ignore
          selectedStatValue.splice(statIndex, 1)
        } else {
          //@ts-ignore
          selectedStatValue.push(stat.val)
        }

        //@ts-ignore
        const allOptionIndex = selectedStatValue.findIndex((s) => s.toLowerCase() === 'all');

        if (selectedStatValue.length > 1 && allOptionIndex >= 0) {
          //@ts-ignore
          selectedStatValue.splice(allOptionIndex, 1)
        }

        if (selectedStatValue.length <= 0) {
          const selectedQuestion = questions.find((q) => q.qid === selectedQuestionId)
          const allOption = selectedQuestion.children.find((q) => q.label.toLowerCase() === 'all')

          if (allOption) {
            //@ts-ignore
            selectedStatValue.push(allOption.val);
          }
        }
      }

    } else {
      //@ts-ignore
      selectedStatValue = stat.val;
    }

    //Only works on coaching forms for now
    const showLoader = typeof window.pullCoachingOverview === 'function'

    this.setState({ selectedStatValue, showLoader, }, () => this.changeQuestion())
  }

  isStatActive(stat: IStatisticData) {
    const { multi, questionId } = this.props
    const { selectedStatValue, questions, } = this.state

    const currentQuestion = questions.find((q) => q.qid === questionId)
    const statVals = stat.value.split('#')
    const statQuestion = statVals[1];

    if (currentQuestion && statQuestion && currentQuestion.display !== statQuestion) {
      return false;
    }

    if (multi && selectedStatValue instanceof Array) {
      return selectedStatValue.findIndex((statInstance) => statInstance === stat.val) >= 0
    }

    return selectedStatValue === stat.val
  }

  getButtonText() {
    const { statId, questionId, useHeaderView } = this.props;
    const { questions, loadingQuestions, selectedStatValue } = this.state;

    if (loadingQuestions || !questionId || !statId) {
      return 'Loading...'
    }

    //@ts-ignore
    const selectedStats: string[] = selectedStatValue instanceof Array ? selectedStatValue : [selectedStatValue];
    const currentQuestion = questions.find((q) => q.qid === questionId)
    let btnText = currentQuestion ? currentQuestion.display : ''

    if (currentQuestion && !useHeaderView) {
      const selectedResponses = currentQuestion.children.filter((c) => selectedStats.indexOf(c.val) >= 0);

      btnText += ': ' + selectedResponses.map((sr) => sr.label.replace('ALL', 'All').replace('%', '')).join(', ')
    }

    return btnText;
  }

  render() {
    const { useHeaderView, useLinkView, questionId, rightAlign } = this.props
    const { questions, selectedQuestionId, showLoader, loadingQuestions } = this.state
    const selectedQuestion = questions.find((q) => q.qid === selectedQuestionId)

    return (
      <Popover
        OnClosed={() => this.setState({ selectedQuestionId: questionId })}
        btnText={this.getButtonText()}
        noContentPadding
        useHeaderView={useHeaderView}
        useLinkView={useLinkView}
        showRefreshSpinner={loadingQuestions}
        rightAlign={rightAlign}
        centerAlign={false}>
        <Row style={{ minWidth: 600 }}>
          <Col xs={6} className="bg-white pl-0 pr-0">
            <DataList>
              {questions.map((questionData) =>
                <DataListRowLink key={questionData.qid}
                  active={selectedQuestionId === questionData.qid}
                  onClick={() => this.setState({ selectedQuestionId: questionData.qid })}>
                  {questionData.display}
                </DataListRowLink>
              )}
            </DataList>
          </Col>
          <Col>
            <section className="data-well">
              {selectedQuestion && selectedQuestion.children.map((stat) => {
                const isActive = this.isStatActive(stat);

                return (
                  <Button key={stat.val + stat.value} block className="bl-btn mb-2"
                    active={isActive && !showLoader}
                    onClick={() => this.triggerStatWasSelected(stat)}
                    showRefreshSpinner={showLoader && isActive}>
                    {stat.label}
                  </Button>
                )
              })}
            </section>
          </Col>
        </Row>
      </Popover>
    )
  }
}
